<template>
  <div class="modal fade" id="add-ip-pool" tabindex="-1" aria-hidden="true">
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <button
            type="button"
            class="btn-close"
            id="add-ip-pool-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="row g-6">
            <div class="col-12">
              <label class="form-label" for="">{{ $t("ips.pool.name") }}</label>
              <input
                type="text"
                class="form-control"
                v-model="ip_pool.name"
                @input="validate"
                :placeholder="$t('ips.pool.name')"
                :class="{ 'is-invalid': errors.name }"
              />
              <div v-if="errors.name" class="invalid-feedback">
                {{ errors.name }}
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ips.pool.start_ip")
              }}</label>
              <input
                type="text"
                v-model="ip_pool.start_ip"
                @input="validate"
                class="form-control"
                placeholder="X.X.X.X"
                :class="{ 'is-invalid': errors.start_ip }"
              />
              <div v-if="errors.start_ip" class="invalid-feedback">
                {{ errors.start_ip }}
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ips.pool.end_ip")
              }}</label>
              <input
                type="text"
                class="form-control"
                v-model="ip_pool.end_ip"
                @input="validate"
                placeholder="X.X.X.X"
                :class="{ 'is-invalid': errors.end_ip }"
              />
              <div v-if="errors.end_ip" class="invalid-feedback">
                {{ errors.end_ip }}
              </div>
            </div>
            <div class="col-12">
              <label class="form-label" for="">{{
                $t("ips.pool.ips_count")
              }}</label>
              <input
                type="text"
                class="form-control"
                disabled
                :value="ip_pool.ip_range.length"
              />
            </div>
            <div class="col-12" v-if="errors.ip_range">
              {{ errors.ip_range }}
            </div>
            <div class="col-12" v-if="error_message">{{ error_message }}</div>
            <div class="col-12 d-flex justify-content-end">
              <button
                class="btn btn-success"
                :disabled="!validated"
                @click.prevent="store"
              >
                {{ ip_pool.id ? $t("control.save") : $t("control.add") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ips2range, ip2long, long2ip } from "../../global_constants.js";
export default {
  name: "ipPoolAdd",
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      ip_pool: {
        name: "",
        start_ip: "",
        end_ip: "",
        ip_range: [],
      },
      errors: {
        name: null,
        start_ip: null,
        end_ip: null,
        ip_range: null,
      },
      validated: false,
      loading: false,
    };
  },
  async created() {
    this.loading = true;
    if (this.$route.query.ip_pool_id) {
      await this.fetchIpPool(this.$route.query.ip_pool_id);
    }
    this.loading = false;
  },
  methods: {
    async fetchIpPool(id) {
      const response = await axios.get(`ip/pool/${id}`);
      if (response.status == 200) {
        this.ip_pool = response.data.data;
        this.validate();
      }
    },
    async store() {
      if (this.ip_pool.id) {
        const response = await axios.post(
          `ip/pool/${this.ip_pool.id}`,
          this.ip_pool,
        );
        if (response.status == 200) {
          document.getElementById("add-ip-pool-close").click();
          this.$notify({
            text: this.$t("messages.ip_pool_updated_successfully"),
            type: "success",
          });
          this.$emit("updated");
        }
      } else {
        const response = await axios.post("ip/pool", this.ip_pool);
        if (response.status == 200) {
          document.getElementById("add-ip-pool-close").click();
          this.$notify({
            text: this.$t("messages.ip_pool_created_successfully"),
            type: "success",
          });
          this.$emit("updated");
        } else if (response.status == 210) {
          this.validated = false;
          this.error_message = this.$t("errors.pool.pool_error");
        }
      }
    },
    ips2range(start, end) {
      return ips2range(start, end);
    },
    ip2long(ip) {
      return ip2long(ip);
    },
    validate() {
      this.errors.name = null;
      this.errors.start_ip = null;
      this.errors.end_ip = null;
      this.errors.ip_range = null;
      this.validated = true;
      this.ip_pool.ip_range = [];
      if (this.ip_pool.name == "") {
        this.validated = false;
        this.errors.name = this.$t("errors.accounts.name_empty");
      }
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.ip_pool.start_ip,
        ) == false
      ) {
        this.validated = false;
        this.errors.start_ip = this.$t("errors.accounts.invalid_ip");
      }
      if (
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          this.ip_pool.end_ip,
        ) == false
      ) {
        this.validated = false;
        this.errors.end_ip = this.$t("errors.accounts.invalid_ip");
      }
      if (
        this.validated &&
        this.ip2long(this.ip_pool.start_ip) > this.ip2long(this.ip_pool.end_ip)
      ) {
        this.validated = false;
        this.errors.ip_range = this.$t("errors.ips.range_reversed");
      }
      if (this.validated) {
        this.ip_pool.ip_range = this.ips2range(
          this.ip_pool.start_ip,
          this.ip_pool.end_ip,
        );
      }
    },
  },
};
</script>
